<div class="container transaction">
  <div class="columns">
    <div class="column col-md-6 col-sm-12">
      <dl>
        <dt>{{ 'online-payment.transaction.amount' | translate }}</dt>
        <dd>{{transaction.value | number:'1.1-2'}} {{ this.transaction.currency ? this.transaction.currency : '€' }}</dd>
      </dl>
    </div>
    <div class="column col-md-6 col-sm-12">
      <form *ngIf="onlinePayementInfo" #billPaymentForm method="post" [action]="onlinePayementInfo.action">
        <input type="hidden" name="version" value="{{ onlinePayementInfo.version }}" />
        <input type="hidden" name="TPE" value="{{ onlinePayementInfo.tpe }}" />
        <input type="hidden" name="date" value="{{ onlinePayementInfo.date }}" />
        <input type="hidden" name="montant" value="{{ onlinePayementInfo.montant }}" />
        <input type="hidden" name="reference" value="{{ onlinePayementInfo.reference }}" />
        <input type="hidden" name="MAC" value="{{ onlinePayementInfo.mac }}" />
        <input type="hidden" name="url_retour_ok" value="{{ onlinePayementInfo.url_retour_ok }}" />
        <input type="hidden" name="url_retour_err" value="{{ onlinePayementInfo.url_retour_err }}" />
        <input type="hidden" name="lgue" value="{{ onlinePayementInfo.lgue }}" />
        <input type="hidden" name="societe" value="{{ onlinePayementInfo.societe }}" />
        <input type="hidden" name="contexte_commande" value="{{ onlinePayementInfo.contexte_commande }}" />
        <input type="hidden" name="texte-libre" value="{{ onlinePayementInfo.textelibre }}" />
        <input type="hidden" name="mail" value="{{ onlinePayementInfo.mail }}" />
        <input type="hidden" name="3dsdebrayable" value="0" />
        <input type="hidden" name="ThreeDSecureChallenge" value="challenge_preferred" />


        <input type="hidden" name="dateech1" value="" />
        <input type="hidden" name="dateech2" value="" />
        <input type="hidden" name="dateech3" value="" />
        <input type="hidden" name="dateech4" value="" />
        <input type="hidden" name="montantech1" value="" />
        <input type="hidden" name="montantech2" value="" />
        <input type="hidden" name="montantech3" value="" />
        <input type="hidden" name="montantech4" value="" />
        <input type="hidden" name="nbrech" value="" />

        <div class="row">
          <button *ngIf="backendCallButton" type="button" class="btn btn-success backendCallButton"
                  [ngClass]="{'btn-mobile': isMobile}" (click)="validateTransaction()" [disabled]="!isValid()">
            <i class="fas fa-check"></i>
            {{ 'online-payment.payButton' | translate }}
          </button>
          <button *ngIf="!backendCallButton" type="submit" class="btn btn-success backendCallButton"
                  [ngClass]="{'btn-mobile': isMobile}">
            <i class="fas fa-check"></i>
            {{ 'online-payment.payButton' | translate }}
          </button>
        </div>
        <div class="row">
          <button type="button" class="btn btn-error payementCancelledButton"
                  [ngClass]="{'btn-mobile': isMobile}" (click)="cancelPayment()">
            <i class="fas fa-times"></i>
            {{ 'online-payment.cancelButton' | translate }}
          </button>
        </div>
        <div class="row">
          <button type="button" class="btn btn-primary paymentInfoButton" [ngClass]="{'btn-mobile': isMobile}"
                  (click)="togglePayInformation()">
            <i class="fas fa-info-circle"></i>
            {{ 'online-payment.payInformationButton' | translate }}
          </button>
        </div>

      </form>
    </div>
  </div>
</div>
